import { Listbox, Transition } from "@headlessui/react";
import React, { useState, useEffect, useRef, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../.././../../assets/svg/solobuilder/close-icon.svg";
import { ReactComponent as DropdownIcon } from "../../../../../../assets/svg/solobuilder/dropdown.svg";
import { RadiusSVG } from "../../../../../../assets/svg/solobuilder/radius.js"
import { BorderSVG } from "../../../../../../assets/svg/solobuilder/borderSVG";
import { BorderTopSVG } from "../../../../../../assets/svg/solobuilder/borderTopSVG";
import { BorderRightSVG } from "../../../../../../assets/svg/solobuilder/borderRightSVG";
import { BorderBottomSVG } from "../../../../../../assets/svg/solobuilder/borderBottomSVG";
import { BorderLeftSVG } from "../../../../../../assets/svg/solobuilder/borderLeftSVG";
import { BorderCustomizeSVG } from "../../../../../../assets/svg/solobuilder/borderCustomizeSVG";
import { AppState } from "../../../../../../stateManager/store";
import { getComponents } from "../../helpers";
import { ColorPicker } from "../ColorPicker";
import { onsetClrPicContext } from "../../../../../../stateManager/store/common/action";


const BorderPopper = (props: any) => {
    const { close, open, borderContext, setBorderContext, onChange } = props;
    const { components } = getComponents()
    const dispatch = useDispatch()
    const { value, where, placeholder, key, label } = borderContext;
    const [values, setValues] = useState(value || {})
    const { colorPickerContext,borderVisibility } = useSelector((state: any) => state.common);
    let colorValue = colorPickerContext?.value
    const [radiusSelection, setRadiusSelection] = useState(false);
    const [borderState,setBorderState] = useState("")
    const [borderWidthValue,setBorderWidthValue] = useState(0);
    const selectedElementId = useSelector((state: AppState) => state.formJson.selectedElementId)
    const ref = useRef(null)
    const component = components[selectedElementId] || {};
    const barRestrict = component.type === "BarChart"
    const handleChange = ((val: any) => {
        if(!barRestrict){
            setBorderState(val.value)
        }
    })

    useEffect(()=>{
        setValues(value)
        setBorderValue((value && value.border) ? value.border.overAll : 0)
    },[where])

    const borderOptions = [
        {
            label: "borderAll",
            value: "borderAll",
        },
        {
            label: "borderTop",
            value: "borderTop",
        },
        {
            label: "borderRight",
            value: "borderRight",
        },
        {
            label: "borderBottom",
            value: "borderBottom",
        },
        {
            label: "borderLeft",
            value: "borderLeft",
        },
        {
            label: "customBorder",
            value: "customBorder",
        }
    ]

    useEffect(() => {
        if (colorValue) {
            setValues((val: any) => ({ ...val, color: colorValue }));
        }
    }, [colorValue])

    useEffect(() => {
        setBorderContext((value: any) => ({ ...value, value: values }))
        onChange(where, values)
    }, [values])

    const onclose = () => {
        close();
    }

    const getBorderIcon = ((val:any,options:boolean)=>{
        if (val === "borderAll"){
            return <BorderSVG color={(borderState === "borderAll" && options) ? "#F1722E" : "#052f35 "}></BorderSVG>
        }
        else if (val === "borderTop") {
            return <BorderTopSVG color={(borderState === "borderTop" && options) ? "#F1722E" : "#052f35 "}></BorderTopSVG>
        } else if (val === "borderRight") {
            return <BorderRightSVG color={(borderState === "borderRight" && options) ? "#F1722E" : "#052f35 "}></BorderRightSVG>
        } else if (val === "borderBottom") {
            return <BorderBottomSVG color={(borderState === "borderBottom" && options) ? "#F1722E" : "#052f35 "}></BorderBottomSVG>
        } else if (val === "borderLeft") {
            return <BorderLeftSVG color={(borderState === "borderLeft" && options) ? "#F1722E" : "#052f35 "}></BorderLeftSVG>
        } else if (val === "customBorder") {
            return <BorderCustomizeSVG color={(borderState === "customBorder" && options) ? "#F1722E" : "#052f35 "}></BorderCustomizeSVG>
        }
    })

    useEffect(() => {
        document.addEventListener('keydown', detectKeyDown)
        return () => {
            document.removeEventListener('keydown', detectKeyDown);
        }
    }, [])

    const detectKeyDown = (e:KeyboardEvent) => {
        if (e.key === "Escape") {
            onclose();
        }
    }

    useEffect(()=>{
        const borders = ["bottom","top","left","right"]
        let tempBorderState = "borderAll";
        if (Object.keys(values?.border).length && Object.keys(values?.border).length === 1 && borders.includes(Object.keys(values?.border)[0])){
            tempBorderState = `border${Object.keys(values?.border)[0].charAt(0).toUpperCase()}${Object.keys(values?.border)[0].slice(1)}`
        } else if (Object.keys(values?.border).length && Object.keys(values?.border).length > 1) {
            tempBorderState = "customBorder";
        }

        if (tempBorderState === "borderTop") { 
            setBorderWidthValue(values?.border?.top ?  values?.border?.top : 0) 
        } else if (tempBorderState === "borderAll")  {
            setBorderWidthValue(values?.border?.overAll ? values?.border?.overAll : 0)
        }else if (tempBorderState === "borderRight"){
            setBorderWidthValue(values?.border?.right ? values?.border?.right : 0)
        } else if (tempBorderState === "borderBottom") {
            setBorderWidthValue(values?.border?.bottom ? values?.border?.bottom : 0 )
        } else if (tempBorderState === "borderLeft"){
            setBorderWidthValue(values?.border?.left ?  values?.border?.left : 0)
        } 
        setBorderState(tempBorderState)
    },[])

    useEffect(()=>{
        if (borderState === "borderTop") { 
            setValues((val: any) => ({ ...val, border: { ["top"]: borderWidthValue } }))
        } else if (borderState === "borderAll")  {
            setValues((val: any) => ({ ...val, border: { ["overAll"]: borderWidthValue } }))
        }else if (borderState === "borderRight"){
            setValues((val: any) => ({ ...val, border: { ["right"]: borderWidthValue } }))
        } else if (borderState === "borderBottom") {
            setValues((val: any) => ({ ...val, border: { ["bottom"]: borderWidthValue } }))
        } else if (borderState === "borderLeft"){
            setValues((val: any) => ({ ...val, border: { ["left"]: borderWidthValue } }))
        } 
    },[borderState,borderWidthValue])

    const setBorderValue = ((value:any)=>{
        setBorderWidthValue(value)
        if (borderState === "borderTop") { 
            setValues((val: any) => ({ ...val, border: { ["top"]: value } }))
        } else if (borderState === "borderAll")  {
            let border = {["overAll"]:value};
            setValues((val: any) => ({ ...val, border: border }))
        }else if (borderState === "borderRight"){
            setValues((val: any) => ({ ...val, border: { ["right"]: value } }))
        } else if (borderState === "borderBottom") {
            setValues((val: any) => ({ ...val, border: { ["bottom"]: value } }))
        } else if (borderState === "borderLeft"){
            setValues((val: any) => ({ ...val, border: { ["left"]: value } }))
        }
    })

    return (
        <>
        {selectedElementId ? <div className="custom-border" data-test-id={`${component?.type}-custom-border`} style={{ bottom: 10 }} ref={ref}  onClick={(e)=>e.stopPropagation()}>
            <div className="w-full flex justify-between items-center text-xs font-semibold"
                style={{ background: "#EFF0F4", height:"30px", width:"100%", padding: "0px 10px" }}>
                <div className="text-lg">{label}</div>
                <CloseIcon className="cursor-pointer" onClick={() => { onclose() }}></CloseIcon>
            </div>
            <div style={{padding: "0px 10px 10px"}}>
            <div><ColorPicker pickerkey="border-color" label="Color" value={values?.color ? values.color : "white"} open={open} close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))} visibility={colorPickerContext?.visibility} width="131px"/></div>
            <div className="panel-div">
                <div className="panel-label">Stroke</div>
                <Dropdown
                    type={component?.type}
                    label="Stroke"
                    options={[{ label: "Solid", value: "solid" }, { label: "Dotted", value: "dotted" }]}
                    onchange={((val: any) => { setValues({ ...values, stroke: val.value }) })}
                    value={values?.stroke ? values.stroke : "Select Stroke"}
                ></Dropdown>
            </div>

            <div className="panel-div">
                <div className="panel-label">Border radius</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <input
                        min={0}
                        onKeyDown={(e) => e.key === '-' && e.preventDefault()}
                        onPaste={(e) => {
                            const pastedText = e.clipboardData.getData('text');
                            if (pastedText.includes('-')) {
                                e.preventDefault(); 
                            }
                        }}
                        type="number"
                        style={{ overflowX: "auto", width: "64px", outline: 0, cursor: `${radiusSelection ? "not-allowed" : "text"}` }}
                        className="panel-input flex items-center"
                        data-test-id={`${component?.type}-BorderRadius_value`}
                        onChange={((e: any) => {
                            const value = e.target.value
                            setValues((val: any) => ({ ...val, radius: { ...val.radius, ["overAll"]: value,["topLeft"]:value ,["topRight"]:value, ["bottomRight"]:value,["bottomLeft"]:value} }))
                        })}
                        disabled={radiusSelection}
                        value={values?.radius?.overAll && values.radius.overAll}
                    ></input>
                    <div data-test-id={`${component?.type}-Border_radius-${radiusSelection}`} style={{ border: `1px solid ${radiusSelection && !barRestrict ? "#F1722E" : "#7D84924B"}`, padding: "6px", height: "28px", width: "60px", outline: 0, borderRadius: "2px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                        className={`flex items-centerrounded-md`} onClick={(() => { setRadiusSelection(!radiusSelection) })}>
                        <RadiusSVG color={radiusSelection ? "#282B31" : "#7D8492"} strokeOpacity={radiusSelection ? "1" : "0.3"}></RadiusSVG>
                    </div>
                </div>
            </div>
            {
                radiusSelection && !barRestrict ?
                    <div data-test-id={`${component?.type}-Border_radius_TRBL_Values`} className="flex flex-row items-center" style={{ gap: "2px", marginTop: "10px", justifyContent: "space-between" }}>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <RadiusSVG strokeTopLeftOpacity={"1"} borderTopLeft={"#282B31"}></RadiusSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-centerrounded-md"
                                data-test-id={`${component?.type}-Border_TopLeft`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, radius: { ...val.radius, ["topLeft"]: value,["overAll"]:0 } }))
                                })}
                                value={values?.radius?.topLeft && values.radius.topLeft}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <RadiusSVG strokeTopRightOpacity={"1"} borderTopRight={"#282B31"}></RadiusSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-centerrounded-md"
                                data-test-id={`${component?.type}-Border_TopRight`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, radius: { ...val.radius, ["topRight"]: value,["overAll"]:0 } }))
                                })}
                                value={values?.radius?.topRight && values.radius.topRight}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <RadiusSVG strokeBottomRightOpacity={"1"} borderBottomRight={"#282B31"}></RadiusSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-centerrounded-md"
                                data-test-id={`${component?.type}-Border_BottomRight`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, radius: { ...val.radius, ["bottomRight"]: value,["overAll"]:0 } }))
                                })}
                                value={values?.radius?.bottomRight && values.radius.bottomRight}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <RadiusSVG strokeBottomLeftOpacity={"1"} borderBottomLeft={"#282B31"}></RadiusSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-centerrounded-md"
                                data-test-id={`${component?.type}-Border_BottomLeft`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, radius: { ...val.radius, ["bottomLeft"]: value,["overAll"]:0 } }))
                                })}
                                value={values?.radius?.bottomLeft && values.radius.bottomLeft}
                            ></input>
                        </div>
                    </div>
                    : <></>
            }
            <div className="panel-div">
                <div className="panel-label">Border width</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <input
                        type="number"
                        style={{ overflowX: "auto", width: "64px", outline: 0, cursor: `${borderState === "customBorder" ? "not-allowed" : "text"}` }}
                        className="panel-input flex items-center"
                        data-test-id={`${component?.type}-Border_Width-${borderState}_value`}
                        onChange={((e: any) => {
                            const value = e.target.value
                            setBorderValue(value)
                        })}
                        disabled={borderState === "customBorder"}
                        value={borderState !== "customBorder" ? borderWidthValue : values?.border?.overAll &&  values.border.overAll}
                    ></input>
                    <div
                        style={{ borderRadius: "2px", height: "28px", width: "60px" }}
                        className="relative bg-white border border-gray-300 text-gray-900 text-lg rounded-lg"
                        data-test-id={`${component?.type}-Border_Width_TRBL_Options-${borderState}`}
                    >
                        <Listbox value={"selected"} onChange={handleChange}>
                            <Listbox.Button
                                style={{ outline: 0, cursor: "pointer", width: "60px", textAlign: "left", paddingLeft: "5px", display: "flex", alignItems: "center" }}
                                className="relative h-full w-full "
                            >
                                <div style={{ width: "50px", display: "inline-block", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", fontSize: "12px", fontWeight: 500 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>{getBorderIcon(borderState,false)}</span>
                                    </div>
                                </div>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <DropdownIcon className="h-3 w-3 text-gray-400" />
                                </span>
                            </Listbox.Button>
                            <Transition
                                as={"div"}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                           { !barRestrict && <Listbox.Options data-test-id={`${component?.type}-borderOptions`} style={{paddingTop: "10px",  border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", height:"130px", overflow:"auto", bottom:"28px"}} className="absolute max-h-60 w-full overflow-auto rounded-md bg-white text-base z-40 cursor-pointer">
                                    {borderOptions.map((type: any, colorIdx: number) => (
                                        <Listbox.Option
                                            key={colorIdx}
                                            style={{ fontSize: 12, fontWeight: 400, lineHeight: "normal", margin: "0px 0px 10px 10px" }}
                                            className={({ active }) => `relative cursor-pointer select-none ${value === type.value||active ? "text-selectedText_color" : "text-unselectedText_color"}`}
                                            value={type}
                                            title={type.label}
                                            data-test-id={`${component?.type}-Border_Width-${type.label}`}
                                        >
                                            {({ selected }) => (
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span
                                                        style={{ fontSize: selected ? "12px" : "11px", lineHeight: "normal" }}
                                                        className={`block truncate  font-medium`}
                                                    >
                                                        {getBorderIcon(type.value,true)}
                                                    </span>
                                                </div>
                                            )}
                                        </Listbox.Option>)
                                    )}
                                </Listbox.Options>}
                            </Transition>
                        </Listbox>
                    </div>
                </div>
            </div>

            {
                borderState === "customBorder" ?
                    <div data-test-id={`${component?.type}-Border_width_TRBL_Values`} className="flex flex-row items-center" style={{ gap: "5px", marginTop: "10px", justifyContent: "space-between" }}>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <BorderLeftSVG color={"#052f35 "}></BorderLeftSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-center"
                                data-test-id={`${component?.type}-Border_Left`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, border: { ...val.border, ["left"]: value,["overAll"]: 0 } }))
                                })}
                                value={ values?.border?.left ?  values.border.left : 0}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <BorderRightSVG color={"#052f35 "}></BorderRightSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-center"
                                data-test-id={`${component?.type}-Border_Right`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, border: { ...val.border, ["right"]: value,["overAll"]: 0 } }))
                                })}
                                value={ values?.border?.right ?  values.border.right : 0}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <BorderTopSVG color={"#052f35 "}></BorderTopSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-center"
                                data-test-id={`${component?.type}-Border_Top`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, border: { ...val.border, ["top"]: value,["overAll"]: 0 } }))
                                })}
                                value={ values?.border?.top ?  values.border.top : 0}
                            ></input>
                        </div>
                        <div style={{ justifyContent: "space-between", borderRadius: "2px", width: "50px", height: "28px", padding: "6px", gap: "5px", alignItems: "center" }} className="panel-input flex border border-solid">
                            <BorderBottomSVG color={"#052f35 "}></BorderBottomSVG>
                            <input
                                type="number"
                                style={{ width: "15px", outline: 0, borderRadius: "2px", padding: "0px 0px", border: "none", overflowX: "auto" }}
                                className="flex items-center"
                                data-test-id={`${component?.type}-Border_Bottom`}
                                onChange={((e: any) => {
                                    const value = e.target.value
                                    setValues((val: any) => ({ ...val, border: { ...val.border, ["bottom"]: value,["overAll"]: 0 } }))
                                })}
                                value={ values?.border?.bottom ?  values.border.bottom : 0}
                            ></input>
                        </div>
                    </div>
                    : <></>
            }
          </div>
        </div> : null}
        </>
    )
}
export default BorderPopper;

interface IProps {
    options: any;
    onchange: any;
    value: string;
    type?: string;
    label?: string;
}
export const Dropdown = ((props: IProps) => {
    const { options, onchange, value, type, label } = props;
    return (
        <div
            style={{width:"131px"}}
            className="panel-input flex items-center relative"
            data-test-id={`dropdown-${type}-${label}`}
        >
            <Listbox value={"selected"} onChange={onchange}>
                <Listbox.Button
                    style={{ outline: 0, cursor: "pointer", width: "131px", textAlign: "left", display: "flex" }}
                    className="relative h-full w-full "
                >
                    <div style={{ width: "110px", display: "inline-block", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", fontSize: "12px", fontWeight: 500 }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span>{value}</span>
                            {value === "dotted" && <div style={{ height: "0px", width: "47px", border: "1px dashed", marginLeft: "22px" }}></div>}
                            {value === "solid" && <div style={{ height: "0px", width: "47px", border: "1px solid", marginLeft: "22px" }}></div>}
                        </div>
                    </div>
                    <span className="pointer-events-none relative flex items-center" style={{top:5}}>
                        <DropdownIcon className="h-3 w-3 text-gray-400" />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                   <Listbox.Options data-test-id={`dropdown_options-${type}-${label}`} style={{ marginTop: "3px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", maxHeight: "175px", paddingBottom: "10px" }} className="absolute max-h-60 w-full overflow-auto rounded-md bg-white text-base z-40 cursor-pointer left-0 top-10">
                        {options.map((type: any, colorIdx: number) => (
                            <Listbox.Option
                                key={colorIdx}
                                style={{ fontSize: 12, fontWeight: 400, margin: "10px 10px 0px 10px" }}
                                className={({ active }) => `relative cursor-pointer select-none ${value === type.value||active ? "text-selectedText_color" : "text-unselectedText_color"}`}
                                value={type}
                                title={type.label}
                                data-test-id={`${props.type}-dropdown_option-${label}-${type?.label}`}
                            >
                                {({ selected }) => (
                                    <span style={{lineHeight: "normal"}} className="flex items-center justify-between">
                                        <span style={{ fontSize: selected ? "12px" : "11px", lineHeight: "normal" }} className={`block truncate  font-medium`}>{type.label}</span>
                                        {type.value === "dotted" && <div style={{ height: "0px", width: "47px", border: "1px dashed", marginLeft: "22px" }}></div>}
                                        {type.value === "solid" && <div style={{ height: "0px", width: "47px", border: "1px solid", marginLeft: "22px" }}></div>}
                                    </span>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </Listbox>
        </div>
    )
})  